import type { QueryClient } from '@tanstack/react-query';

import { meAccessQueryOptions, sidebarQueryOptions } from '../access/queryOptions';
import i18n from '../i18n';
import { languageInUse } from '../i18n/languages';
import { onboardingStatusQueryOptions } from '../modules/onboarding';
import { sessionQueryOptions } from '../session/queryOptions';

/**
 * Starts the signed-in shell's reads before any screen mounts, without holding the
 * route on them: the session first, then — for someone the server says is signed
 * in — their access, sidebar and onboarding status together.
 */
export const bootLoader = (queryClient: QueryClient) => async (): Promise<null> => {
  void queryClient
    .fetchQuery(sessionQueryOptions())
    .then((session) => {
      if (session.status !== 'signedIn') return;
      void queryClient.prefetchQuery(meAccessQueryOptions());
      void queryClient.prefetchQuery(sidebarQueryOptions(languageInUse(i18n)));
      void queryClient.prefetchQuery(onboardingStatusQueryOptions());
    })
    .catch(() => undefined);
  return null;
};
